import { Button, Group, Modal, Text } from '@mantine/core';
import { CompanyAppendix } from '../../types';

type ArchiveAppendixModalProps = {
  opened: boolean;
  onClose: () => void;
  appendices: CompanyAppendix[];
  onConfirm: () => Promise<void>;
  isLoading: boolean;
};

export default function ArchiveAppendixModal({
  opened,
  onClose,
  appendices,
  onConfirm,
  isLoading,
}: ArchiveAppendixModalProps) {
  const count = appendices.length;
  const title = count === 1 ? 'Archive appendix' : `Archive ${count} appendices`;

  return (
    <Modal opened={opened} onClose={onClose} title={title} centered>
      <Text mb="md">
        {count === 1 ? (
          <>
            Are you sure you want to archive <strong>{appendices[0]?.file.fileName}</strong>? It
            will no longer be available for selection in suitability reports.
          </>
        ) : (
          <>
            Are you sure you want to archive these <strong>{count}</strong> appendices? They will no
            longer be available for selection in suitability reports.
          </>
        )}
      </Text>
      <Group justify="flex-end">
        <Button variant="subtle" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} loading={isLoading}>
          Archive
        </Button>
      </Group>
    </Modal>
  );
}
